import {h} from 'preact';

// since users may paste email addresses in the form of "<myemail@mydomain.com>"
// we need to escape <> symbols in order not to be mistaken as html tags
function encodeSpecialCharacters(string) {
	const conversions = {'<': '&lt;', '>': '&gt;'};

	return string.replace(/[<>]/g, find => conversions[find]);
}

function highlightQuery(string, query) {
	const regex = new RegExp(query, 'g');

	return string.replace(regex, match =>
		`<mark class='c-text-highlight--valid'>${match}</mark>`);
}

// we wrap every identified email address with the 'mark' tag in order to highlight it
function convertTextarea(emailsArray, textareaValue) {
	for (const email of emailsArray) {
		textareaValue = highlightQuery(textareaValue, email);
	}

	return {__html: textareaValue};
}

export function AddAssociatedUsersHighlighEmails({identifiedEmails, emailValue, showConfirmationMessage}) {
	const confirmationMessage = (identifiedEmails.length > 1) ?
		`Are these the ${identifiedEmails.length} email addresses you want to invite?` :
		'Is this the email address you want to invite?';

	return (
		<div>
			{showConfirmationMessage ? // edit-feedback phase
				<p class="u-margin-bottom-small"> Most recent text</p> :
				<p>
					<strong>
						{confirmationMessage}
					</strong>
					<br aria-hidden="true" />We also found <em>other text</em>.
				</p>}

			{/* eslint-disable-next-line react/no-danger */}
			<div class="c-text-highlight-container" dangerouslySetInnerHTML={convertTextarea(identifiedEmails, encodeSpecialCharacters(emailValue))} />
		</div>
	);
}

export default AddAssociatedUsersHighlighEmails;
